import { useSearch } from "@tanstack/react-router";
import { useQuery } from '@tanstack/react-query';
import { ReportViewMode, localStateKeys } from '../utils/reportviewutils';
import ReportSideBar from '../components/ReportSideBar';
import Measurement  from '../components/Measurement';
import Finding from '../components/Finding';
import Comment from '../components/Comment';
import '../styles/main.css';

export type ReportViewLaunchArg = {
  studyInsUid: string;
  app: string;
  subApp: string;
}  

function ReportView() {
  const launchArg = useSearch({ from: "/reportview" });

  const { data : viewMode } = useQuery({
    queryKey: localStateKeys.viewMode,
    queryFn: async () : Promise<ReportViewMode> => {
      return Promise.resolve(ReportViewMode.Measurement);
    },
    staleTime: Infinity,
  });

  return (
    <>
      { 
        (() => {
          launchArg;
          console.log('report view page is now rendering...');
          return null;
        })() && undefined
      }
      <header>
        <p>Header [TBD]</p>       
      </header>
      <aside>
        <ReportSideBar/>
      </aside>
      <main>
        <article>
          { viewMode === ReportViewMode.Measurement 
            ? <Measurement/> : null }
          { viewMode === ReportViewMode.Findings 
            ? <Finding/>: null }
          { viewMode === ReportViewMode.Comment 
            ? <Comment/>: null }    
        </article>
      </main>
      <footer>

      </footer>
    </>
  )
}

export default ReportView;
